import { Injectable } from '@angular/core';
import json from 'assets/content/text.json';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class SubjectService {
    public subject = new Subject<any>();

    constructor() {}

    sendSearch(filters: any) {
        this.subject.next({ searching: filters });
    }

    getSearch(): Observable<any> {
        return this.subject.asObservable();
    }
}
